import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, Router } from '@angular/router'
import { UnespCoreMessageService } from '@unesp/core'
import { StorageFolder } from 'src/app/enums/storage-folder'
import { DiscentePlanoAtividadeEntregar } from 'src/app/models/discente-plano-atividade-entregar'
import { DiscenteService } from 'src/app/services/discente-service'
import { PdfViewerComponent } from '../../comum/pdf-viewer/pdf-viewer.component'

@Component({
  selector: 'app-discente-plano-atividade-entregar',
  templateUrl: './discente-plano-atividade-entregar.component.html',
  styleUrls: ['./discente-plano-atividade-entregar.component.css'],
  standalone: false
})
export class DiscentePlanoAtividadeEntregarComponent implements OnInit {
  id: number = 0
  data?: DiscentePlanoAtividadeEntregar
  arquivoJaEnviado: boolean = false

  arquivo?: File
  arquivoNome: string = ''
  form = new FormGroup({
    arquivo: new FormControl('', Validators.required),
  })

  constructor(
    private route: ActivatedRoute,
    private discenteService: DiscenteService,
    private unespCoreMessageService: UnespCoreMessageService,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id']
      this.discenteService.entregarPlanoAtividade(this.id).subscribe(data => {
        this.data = data
        this.arquivoNome = data.arquivo
      })
    })
  }

  applyTouchedToInvalidFields() {
    for (const name in this.form.controls) {
      if (this.form.get(name)?.invalid) {
        this.form.get(name)?.markAsTouched()
      }
    }
  }

  gravar(): void {
    this.applyTouchedToInvalidFields()
    if (!this.form.valid) {
      this.unespCoreMessageService.showMessageError('O formulário não foi preenchido corretamente')
      return
    }
    const formData = new FormData()
    if (this.form.controls['arquivo'].getRawValue()) {
      formData.append('arquivo', this.arquivo!)
      this.discenteService.registrarPlanoAtividade(this.id, formData).subscribe(data => {
        if (data.status === 'ok') {
          this.unespCoreMessageService.showMessageSuccess('Arquivo enviado com sucesso')
          this.router.navigate(['/discente/entregar-plano-atividade'])
        } else {
          this.unespCoreMessageService.showMessageError(data.message)
        }
      })
    }
  }

  onFileSelected(event: any): void {
    var file = event.target.files[0]
    if (file) {
      if (file.type !== 'application/pdf') {
        this.unespCoreMessageService.showMessageError('Apenas arquivo do tipo PDF é permitido.')
        this.form.controls['arquivo'].reset()
        this.arquivo = undefined
        this.arquivoNome = ''
        return
      }
      if (file.size > 5120000) {
        this.unespCoreMessageService.showMessageError('O arquivo excedeu o limite de 5 MB permitido.')
        this.form.reset()
        this.arquivo = undefined
        this.arquivoNome = ''
        return
      }
    }
    this.arquivo = file
    this.arquivoNome = file.name
  }

  download(): void {
    this.discenteService.download(StorageFolder.plano_atividade, this.data!.idInscricao).subscribe(data => {
      let blob = new Blob([data], {
        type: 'application/pdf',
      })
      let url = window.URL.createObjectURL(blob)
      this.dialog.open(PdfViewerComponent, {
        data: {
          titulo: this.data?.nomeDisciplina,
          url: url,
        },
        width: '80%',
        height: '90%',
      })
    })
  }
}
